import { useReducer, useState } from 'react';
import { Item } from '../../utils/sharedTypes';
import DemosFilterBar from './DemosFilterBar';
import DemosOptionsBar from './DemosOptionsBar';
import DemosTable from './DemosTable';
import { DemosItemFilter } from './demosTypes';

const initialFilters: DemosItemFilter = {
  company: null,
  serial: '',
  startDate: '',
  endDate: '',
  demoActive: '',
};

const Demos = () => {
  const [filters, setFilters] = useReducer(
    (curVals: DemosItemFilter, newVals: any) => ({
      ...curVals,
      ...newVals,
    }),
    initialFilters
  );
  const [selectedDemos, setSelectedDemos] = useState<Item[]>([]);
  const [editModalOpenFlag, setEditModalOpenFlag] = useState<boolean>(false);
  return (
    <>
      <DemosFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
      />
      <DemosOptionsBar
        selectedDemos={selectedDemos}
        editModalOpenFlag={editModalOpenFlag}
        setEditModalOpenFlag={setEditModalOpenFlag}
        setSelectedDemos={setSelectedDemos}
      />
      <DemosTable
        setEditModalOpenFlag={setEditModalOpenFlag}
        setSelectedDemos={setSelectedDemos}
        filters={filters}
      />
    </>
  );
};

export default Demos;
